import { useState } from 'react';
import TeacherReviewModal from '../components/TeacherReviewModal';
import styles from './StudentRow.module.scss';
import { InlineIcon } from '@iconify/react';
import circleCheck from '@iconify/icons-akar-icons/circle-check';
import { Assignment, EmbeddedContent, Module } from '@peekapak/types/LessonPlanTypes';

interface StrengthsExplanation {
  strength: string;
  description: string;
}

interface StrengthsEvaluation extends EmbeddedContent {
  questions: StrengthsQuestions[];
  tiebreakerQuestions: StrengthsQuestions[];
  content: StrengthsExplanation[];
  title: string;
}
interface Props {
  reviewContent: Module['studentContent'][0];
  content: StrengthsEvaluation;
  userId: string;
  firstName: string;
  lastName: string;
  isShowStudents: boolean;
  assignment: Assignment | { module: string; status: string };
  strength: string[];
  getTextColour: (moduleData: StrengthsEvaluation, strength: string) => string;
}

interface StrengthsQuestions {
  index: number;
  question1: string;
  question2: string;
  strength1: string;
  strength2: string;
}

const BlankCell = () => {
  return (
    <div className={styles.dataCell}>
      <h4>-</h4>
    </div>
  );
};

const AssignmentStatus = (status: { status: string }) => {
  if (status.status === 'submitted') {
    return (
      <div className={styles.dataCell}>
        <InlineIcon icon={circleCheck} width={24} color='#00ca48' />
      </div>
    );
  }
  if (status.status === 'inProgress') {
    return (
      <div className={styles.dataCell}>
        <span className={styles.circleOutline} />
      </div>
    );
  }
  return (
    <div className={styles.dataCell}>
      <h4>-</h4>
    </div>
  );
};

const StudentRowSingleUnit = ({
  firstName,
  reviewContent,
  lastName,
  isShowStudents,
  assignment,
  content,
  strength,
  getTextColour,
  userId,
}: Props): JSX.Element => {
  const [isReviewStudentWork, setReviewStudentWork] = useState(false);
  const handleClick = () => {
    setReviewStudentWork(true);
  };
  const handleCloseModal = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) setReviewStudentWork(false);
  };
  return (
    <>
      <div
        className={assignment.status === 'submitted' ? styles.containerClickable : styles.container}
        onClick={assignment.status === 'submitted' ? handleClick : undefined}
      >
        <div className={styles.nameCell}>
          <h4>{isShowStudents ? `${firstName} ${lastName ?? ''}` : 'Private'}</h4>
        </div>

        <div className={styles.singleUnitContainer}>
          <AssignmentStatus status={assignment.status} />

          {assignment.status === 'submitted' && strength && strength.length === 1 ? (
            <div
              key={`${firstName} ${lastName} ${assignment.status}`}
              className={styles.dataCell}
              role='button'
              style={{
                backgroundColor: getTextColour(content, strength.toString()),
              }}
            >
              <h4
                style={
                  getTextColour(content, strength.toString()) === '#e78d60' ? { color: 'white' } : { color: 'inherit' }
                }
              >
                {strength.toString()}
              </h4>
            </div>
          ) : (
            <BlankCell key={`${firstName}${lastName} no data`} />
          )}
        </div>
      </div>
      {isReviewStudentWork && (
        <div className={styles.reviewModal} onClick={(e) => handleCloseModal(e)}>
          <TeacherReviewModal
            assetImage={reviewContent.representativeImage}
            studentId={userId}
            title={content.title}
            createdAt={assignment?.createdAt}
            displayData={reviewContent.content}
            handleCloseModal={handleCloseModal}
            firstName={firstName}
            lastName={lastName}
          />
        </div>
      )}
    </>
  );
};

export default StudentRowSingleUnit;
